import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const CustomerGroupAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.customerGroupAccess
        ? setValues((j) => ({
            ...j,
            customerGroup: {
              create: true,
              edit: true,
              delete: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            customerGroup: {
              create: false,
              edit: false,
              delete: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.customerGroupAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      customerGroup: { ...j.customerGroup, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.customerGroupAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.customerGroup?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.customerGroup?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.customerGroup?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default CustomerGroupAccess;
